import React from 'react';
import Headline from '../../partials/Headline';
import PriceList from '../../components/PriceList';

const PricesPage = () => {

  const headline = 'ceník masáže';
  const pricesArray = [
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
  ];
  const headline2 = 'ceník masáže 2';
  const pricesArray2 = [
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
  ];
  const headline3 = 'ceník masáže 3';
  const pricesArray3 = [
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
    {
      name: 'Masáže 30 min',
      value: '500,-'
    },
  ];

  return (
    <div className="page page-prices">
      <Headline h={1}>
        Ceník
      </Headline>
      <PriceList
        headline={headline}
        pricesArray={pricesArray}
      />
      <PriceList
        headline={headline2}
        pricesArray={pricesArray2}
      />
      <PriceList
        headline={headline3}
        pricesArray={pricesArray3}
      />
    </div>
  );
}

export default PricesPage;